import {FC, SVGProps} from 'react';

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M13 4H15V24H13V4Z" fill="currentColor" />
		<path d="M4 13H24V15H4V13Z" fill="currentColor" />
	</svg>
);
